(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('portals', {
                parent: 'app',
                url: '/portals',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.account.portals'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/pap/infor-suspect-portal/infor-suspect-portal.html',
                        controller: 'PortalsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '0',
                        squash: true
                    },
                    sort: {
                        value: 'userName,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil',
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort)
                            };
                        }],
                    translatePartialLoader: ['$translate',
                        '$translatePartialLoader',
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('reports');
                            return $translate.refresh();
                        }]
                }
            })
            
        ;
    }

})();
